import Vue from 'vue'
import Router from 'vue-router'
import DemoRoom from '@/components/DemoRoom'
import Lobby from '@/components/Lobby'
import NotFound from '@/components/_404';

Vue.use(Router);

export default new Router({
  routes: [
      {
          path: '/',
          name:'Lobby',
          component:Lobby,
          // redirect: '/room/20161'
      },
      {
        path: '/room/:id',
        name: 'DemoRoom',
        component: DemoRoom,
          props:true
      },
      {
          path: '*',
          name: '404',
          component: NotFound
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js